import 'css-chunksrc/client/pages/zonesPage/wbsPage/heading/styles.scss';export default {
  "heading": "_heading_10agc_1",
  "row": "_row_10agc_7",
  "label": "_label_10agc_23",
  "hide": "_hide_10agc_30",
  "contextualMenu": "_contextualMenu_10agc_34",
  "contextualMenuIcon": "_contextualMenuIcon_10agc_38",
  "wbsConfigurationIcon": "_wbsConfigurationIcon_10agc_46"
};